"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchText = fetchText;
async function fetchText(url) {
    const result = await fetch(url);
    if (result.status !== 200) {
        throw new Error(String(result.status));
    }
    return result.text();
}
//# sourceMappingURL=fetchText.js.map